module.exports = __webpack_public_path__ + "static/fram-sig-f237c05845fb46817b9785c179621b1c.svg";